// extracted by mini-css-extract-plugin
export default {"eventsWrapper":"Events_eventsWrapper__GGcmS","eventName":"Events_eventName__MCXR0","section":"Events_section__tJZl0"};